module.exports = __webpack_public_path__ + "img/chart-temperature.84088eb9.svg";